import * as React from "react";
import { IAccessContext, IAccessContextType } from "../interfaces/interface";

const initialState: IAccessContext = {
    access_id: 0,
    school_cnpj: '',
    students_re: 0,
    profile: 'NOK',
  };

// Cria o contexto com um valor inicial vazio
const AccessContext = React.createContext<IAccessContextType | undefined>(undefined);

// Provedor do contexto para encapsular componentes que precisarão acessar ou manipular `IAccessContext`
export const AccessContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [access_data, setAccess_data] = React.useState<IAccessContext>(initialState);
    return (
        <AccessContext.Provider value={{ access_data, setAccess_data }}>
            { children }
        </AccessContext.Provider>
    );
};

// Hook personalizado para acessar o contexto facilmente em outros componentes
export const useAccessContext = (): IAccessContextType => {
    const context = React.useContext(AccessContext);
    if (!context) {
        throw new Error("useAccessContext deve ser usado dentro de um AccessContextProvider");
    }
    return context;
};